/*@flow*/
import isType from './isType';
import getFunctionName from './getFunctionName';
import type { TypeT } from './types';

type Fun = {
  (...args: Array<any>): any,
  displayName: string,
  name: string,
};

export default function getTypeName(ctor: TypeT<*> | Fun): string {
  return isType(ctor) ? ctor.displayName : getFunctionName(ctor);
}
